import React from 'react'
import { Button, Header, Image, Modal } from 'semantic-ui-react'
import { Redirect } from 'react-router-dom';
import { history } from '../store'
import { Text } from '../helpers/language';

class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        error: null,
        errorInfo: null,
        open: false,
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
      open: true,
    });
  }

  handleClick() {
    this.setState({open: false})
    window.location = '/'
  }

  render() {
    if (this.state.error){ 
      return (
      <>
        <Modal open={this.state.open} centered={false}>
          <Modal.Header><Text tid='generic_fail_message' /></Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <Header>{this.state.error && this.state.error.toString()}</Header>
              {this.state.errorInfo.componentStack}
            </Modal.Description>
          </Modal.Content>
        <Modal.Actions>
          <Button className='lisia-blue' onClick={() => this.handleClick()}><Text tid='go_to_app' /></Button>
        </Modal.Actions>
        </Modal>
      </>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
